module.exports = __webpack_public_path__ + "static/media/alert_balanced.4eeaec47.svg";